import {GenericProvider} from "./generic-provider.js";


/**
 * Uniwersalny provider do przechowywania kolekcji lokalnie w STORE
 * NIE wczytuje kolekcji z serwera
 */
export class LocalProvider extends GenericProvider {

    /**
     * {@inheritDoc}
     * @return {Promise<Array>}
     */
    async all() {
        return this.getAll();
    }

    /**
     * {@inheritDoc}
     * @return {Promise<[]>}
     */
    async fetchAll() {
        return this.getAll();
    }

    /**
     * {@inheritDoc}
     * @param pkValue
     * @return {Promise<Object|null>}
     */
    async getByPk(pkValue) {
        let model = this.findByPk(pkValue);
        if (!model) {
            model = await this.fetchSingle(pkValue);
        }
        return model;
    }

}
